import {createSlice} from '@reduxjs/toolkit'

export const categorizedInterestTagSlice = createSlice({
  name: 'categorizedInterestTag',
  initialState: {
    categorisedInterestTagRefData: null,
    isCategorizedInterestRefDataLoading: false,
    isCategorizedInterestRefDataError: false,
    categoryTagName: '',
    specificCategoryTagRefData: [],
    categoryInterestTagCount: 0,
    searchedInterestTag: '',
    selectedInterestOptions: [],
    appliedInterestTags: []
  },
  reducers: {
    setCategorisedInterestTagRefData: (state, action) => {
      state.categorisedInterestTagRefData = action.payload
    },
    setCategorisedInterestTagRefDataLoading: (state, action) => {
      state.isCategorizedInterestRefDataLoading = action.payload
    },
    setCategorisedInterestTagRefDataError: (state, action) => {
      state.isCategorizedInterestRefDataError = action.payload
    },
    setSpecificCategoryTagRefData: (state, action) => {
      state.specificCategoryTagRefData.push(action.payload)
    },
    setCategoryTagName: (state, action) => {
      state.categoryTagName = action.payload
    },
    setTotalInterestTagCount: (state, action) => {
      state.categoryInterestTagCount = action.payload
    },
    setRemoveSpecificCategoryTagRefData: (state, action) => {
      state.specificCategoryTagRefData = []
    },
    setSearchedInterestTag: (state, action) => {
      state.searchedInterestTag = action.payload
    },
    setSelectedInterestOptions: (state, action) => {
      state.selectedInterestOptions = action.payload
    },
    setClearSelectedInterestOptions: (state) => {
      state.selectedInterestOptions = []
    },
    setAppliedInterestTags: (state, action) => {
      state.appliedInterestTags = action.payload
    }
  }
})

export const {
  setCategorisedInterestTagRefData,
  setCategorisedInterestTagRefDataLoading,
  setCategorisedInterestTagRefDataError,
  setSpecificCategoryTagRefData,
  setRemoveSpecificCategoryTagRefData,
  setCategoryTagName,
  setTotalInterestTagCount,
  setSearchedInterestTag,
  setSelectedInterestOptions,
  setClearSelectedInterestOptions,
  setAppliedInterestTags
} = categorizedInterestTagSlice.actions

export default categorizedInterestTagSlice.reducer
